import { Dispatch, FC, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';
import { ImageWithFallback } from '../';
import Question from '../../../assets/images/question-mark.svg';
import styles from './Select.module.scss';
import classNames from 'classnames';

interface Selects {
  value: string | number;
  grayValue?: string | number;
  img?: string;
}

interface SelectProps {
  current: string | number;
  selects: Selects[];
  setValue: Dispatch<SetStateAction<string | number>>;
  selected?: boolean;
  addImage?: boolean;
  customButtonClass?: string;
}

export const Select: FC<SelectProps> = ({ current, selects, setValue, selected = false, addImage = true, customButtonClass = "" }) => {
  const isImageNeeded = () => addImage && selects.find((item) => item.value === current)?.img;

  return (
    <>
      {
        selected
        ? <div className={classNames(styles.dropdown_button, styles.selected_dropdown)}>
            {isImageNeeded() && <ImageWithFallback
              src={selects.find((item) => item.value === current)?.img}
              fallbackSrc={Question}
              alt="icon"
              className={styles.dropdown_icon}
            />}
            {current}
          </div>
        : <Dropdown className={styles.container}>
            <Dropdown.Toggle id="select-dropdown-basic" className={classNames(styles.dropdown_button, customButtonClass)}>
              {isImageNeeded() && <ImageWithFallback
                src={selects.find((item) => item.value === current)?.img}
                fallbackSrc={Question}
                alt="icon"
                className={styles.dropdown_icon}
              />}
              {current}
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.menu}>
              {selects.map((item) => (
                <Dropdown.Item id={item.value.toString()} key={item.value} onClick={() => setValue(item.value)} className={styles.menu_item}>
                  {addImage && item.img && <ImageWithFallback className={styles.dropdown_icon} src={item.img} fallbackSrc={Question} alt="icon" />}
                  {item.value}
                  {item.grayValue && <span className={styles.gray_item}>{ item.grayValue }</span>}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
      }
    </>
  );
};
